import { useState } from "react";
import { createModel } from "hox";
import { message } from 'antd';
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/FmsTypes";
import { UserTypeEnum } from "@/types/FmsEnums";
import { useGlobalModel } from "@/model/globalModel";
import { transPgToPagination } from "@/views/base/app/appModel";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { invoiceManageService } from "@/views/invoice/manage/InvoiceManageService";
import { InvoiceBillSearch, InvoiceIdentify } from "@/views/invoice/manage/InvoiceManageTypes";
import { useDetailModel } from "../detailModel";

export const uploadDataModel = createModel(function () {
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    const { user: { shopCode }, beDs } = useGlobalModel();
    const { customerCode, invoiceNumsRef } = useDetailModel();

    //查询条件
    const [searchParam, setSearchParam] = useState<InvoiceBillSearch>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<InvoiceIdentify[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<InvoiceIdentify[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    //发票匹配
    const [invoiceMateVisible, setInvoiceMateVisible] = useState(false);

    //明细修改
    const [detailVisible, setDetailVisible] = useState(false);
    const [detail, setDetail] = useState<InvoiceIdentify>();

    const onSearch = () => {
        loadData({ pageNum: 1 }, { ...searchParam })
    }

    const onSearchInvoiceNums = () => {
        updateSearchParam({ ...searchParam, invoiceNums: invoiceNumsRef.current });
        loadData({ pageNum: 1 }, { ...searchParam, invoiceNums: invoiceNumsRef.current })
    }

    const onReset = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        setSelectedData([])
        loadData(initPgCfg, {});
    }

    const updateSearchParam = (updateParam: InvoiceBillSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: InvoiceBillSearch = searchParam) => {
        const searchParams = {
            ...defaultMdCmParam,
            ...searchValue,
            shopCode,
            partnerCode: customerCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await invoiceManageService.invoiceUploadPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }

    const next = (record?: InvoiceIdentify, offset?: number) => {
        if (record != null) {
            let findIndex = dataSource.map(r => r.id).indexOf(record.id);
            let index = findIndex + (offset ?? 0)
            if (index < 0) {
                message.error("没有上一条数据")
            }
            else if (index >= dataSource.length) {
                message.error("没有下一条数据")
            }
            else {
                setDetail(dataSource[index])
            }
        }
    }

    return {
        /***field***/
        initPgCfg,
        searchParam,
        dataSource,
        pgCfg,
        beDs,
        selectedRowKeys,
        selectedData,
        invoiceMateVisible,
        detailVisible,
        detail,
        /***method***/
        setDataSource,
        updateSearchParam,
        loadData,
        onSearch,
        onSearchInvoiceNums,
        onReset,
        setSelectedRowKeys,
        setSelectedData,
        setInvoiceMateVisible,
        setDetailVisible,
        setDetail,
        next
    }
});
